module.exports = __webpack_public_path__ + "img/tuletorn_inimene.f1f68f1f.jpg";